export const WHATSAPP_URL = `https://wa.me/5511977074083?text=${encodeURIComponent(
  "Olá! Preciso de um serviço hidráulico/elétrico, quero um orçamento na hora."
)}`;

export const PHONE_DISPLAY = "(11) 97707-4083";
export const PHONE_TEL = "tel:+5511977074083";

export const MARQUEE_ITEMS = [
  "Serviços hidráulicos e elétricos",
  "Atendimento para residências, condomínios e empresas",
  "Orçamento apresentado antes da contratação",
  "Atendimento conforme disponibilidade ou agendamento",
];

export const scrollToHash = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72, duration: 1.2 });
    return;
  }
  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};
